function isEmailValid(_ref) {
  var email = _ref.email;
  var emailReg = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/;
  return emailReg.test(email.toLowerCase());
}
function isPasswordValid(_ref2) {
  var password = _ref2.password;
  var passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\S]{8,}$/;
  return passwordReg.test(password);
}
function isConfirmPasswordValid(_ref3) {
  var password = _ref3.password,
    confirmPassword = _ref3.confirmPassword;
  return password === confirmPassword;
}
function isMobilePhoneValid(_ref4) {
  var mobilePhone = _ref4.mobilePhone;
  var mobilePhoneReg = /^\d{10}$|^\d{3}-\d{3}-\d{4}$|^\d{3} \d{3} \d{4}$/;
  return mobilePhoneReg.test(mobilePhone);
}
function isMonthValid(_ref5) {
  var months = _ref5.months;
  var m = Number(months);
  return !(Number.isNaN(m) || m < 1 || m > 12);
}
function isDayValid(_ref6) {
  var days = _ref6.days;
  var d = Number(days);
  return !(Number.isNaN(d) || d < 1 || d > 31);
}
function isYearValid(_ref7) {
  var years = _ref7.years;
  var y = Number(years);
  return !(Number.isNaN(y) || y < 1900 || y > new Date().getFullYear());
}
function coppaValid(_ref8) {
  var dob = _ref8.dob;
  var today = new Date();
  var birthDate = new Date(dob);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
    age--;
  }
  return age >= 13;
}
function _getReason() {
  var validFuncResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var minResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var maxResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!minResult) {
    return "min";
  }
  if (!maxResult) {
    return "max";
  }
  if (!validFuncResult) {
    return "func";
  }
  return null;
}
function isValid(values) {
  var inputRules = {
    email: {
      validFunc: isEmailValid,
      min: 1,
      max: 256
    },
    password: {
      validFunc: isPasswordValid,
      min: 8,
      max: 15
    },
    confirmPassword: {
      validFunc: isConfirmPasswordValid,
      min: 1,
      max: 256
    },
    months: {
      validFunc: isMonthValid,
      min: 1,
      max: 2
    },
    days: {
      validFunc: isDayValid,
      min: 1,
      max: 2
    },
    years: {
      validFunc: isYearValid,
      min: 4,
      max: 4
    },
    dob: {
      validFunc: coppaValid
    },
    mobilePhone: {
      validFunc: isMobilePhoneValid,
      min: 1,
      max: 20
    }
  };
  var output = Object.keys(values).reduce(function (prev, inputKey) {
    if (inputRules[inputKey]) {
      try {
        var rule = inputRules[inputKey];
        if (!rule) {
          return prev;
        }
        var validFuncResult = rule.validFunc(values);
        if (inputKey === "dob") {
          var isDobValid = validFuncResult;
          prev.dobValid = isDobValid;
          prev.dobReason = _getReason(validFuncResult);
        } else {
          var minResult = values[inputKey].length >= rule.min;
          var maxResult = values[inputKey].length <= rule.max;
          prev["".concat(inputKey, "Valid")] = validFuncResult && minResult && maxResult;
          prev["".concat(inputKey, "Reason")] = _getReason(validFuncResult, minResult, maxResult);
        }
      } catch (error) {
        console.error(error);
        prev["".concat(inputKey, "Valid")] = false;
      }
    }
    return prev;
  }, {});
  return output;
}
export default isValid;